import { useCallback } from 'react';
import compact from 'lodash/compact';

import {
  FetchProductsCacheKeys,
  UpdateProductCacheAction
} from '../../../../../productsTypes';

import { FetchProductsSetsCacheKeys } from '../../../../../../productsSets/productsSetsTypes';

import {
  TOGGLE_PRODUCT_FAVORITE_QUERY,
  ToggleProductFavoriteQueryResponse
} from '../../../../../queries/toggleProductFavorite.query';

import { useToggleProductFavorite } from '../../../../../hooks/useToggleProductFavorite';

import { useShowToastOnErrorChange } from '../../../../../../../common/hooks/useShowToastOnErrorChange';

import { ProductCache } from '../../../../../ProductCache';
import { ProductsSetCache } from '../../../../../../productsSets/ProductsSetCache';

import { ProductsListItemLightboxFavoriteButtonProduct } from './ProductsListItemLightboxFavoriteButton.types';

interface useProductsListItemLightboxFavoriteButtonProps {
  product: ProductsListItemLightboxFavoriteButtonProduct;
  productsCacheKeys?: FetchProductsCacheKeys;
  productsSetCacheKeys?: FetchProductsSetsCacheKeys;
  updateProductCache?: UpdateProductCacheAction<ProductsListItemLightboxFavoriteButtonProduct>;
}

function useProductsListItemLightboxFavoriteButton({
  product,
  productsCacheKeys,
  productsSetCacheKeys,
  updateProductCache
}: useProductsListItemLightboxFavoriteButtonProps) {
  const { toggleProductFavorite, toggleProductFavoriteErrorMessage } =
    useToggleProductFavorite<ToggleProductFavoriteQueryResponse>({
      query: TOGGLE_PRODUCT_FAVORITE_QUERY,
      cacheKeys: compact([
        ProductCache.indexCacheKey(),
        ProductsSetCache.showCacheKey(),
        ...(productsCacheKeys || []),
        ...(productsSetCacheKeys || [])
      ]),
      updateIndexProductCache: updateProductCache
    });

  const handleToggleFavorite = useCallback<() => void>(
    () => toggleProductFavorite({ uuid: product.uuid }),
    [product, toggleProductFavorite]
  );

  useShowToastOnErrorChange({ error: toggleProductFavoriteErrorMessage });

  return {
    handleToggleFavorite
  };
}

export default useProductsListItemLightboxFavoriteButton;
